module.exports = "http://cdn.realive.com.ua/src/views/fractions/war/map/map.jpg";